<template lang="pug">
section.mhek__additional-news.module-layout(aria-labelledby="mhek-additional-news")
	h2#mhek-additional-news.sr-only(ref="header", tabindex=0) More news
	.news-container
		NewsTags
		.news-col
			NewsList(v-show="formState == FORM_STATES.FORM")
			TechnicalError(v-if="formState == FORM_STATES.TECHNICAL_ERROR")
			NoResult(v-if="formState == FORM_STATES.NO_RESULT")
			.news-spinner(v-if="formState == FORM_STATES.LOADING")
				VueSpinner
	VuePagination(v-model="currentPage", :total-rows="totalRows", :has-max-page="false", :page-size="pageSize")
</template>
<script>
import NewsList from './news-list/news-list.vue';
import NewsTags from './news-tags/news-tags.vue';
import VuePagination from '@ui-common/vue-pagination';
import VueSpinner from '@ui-common/vue-spinner';
import TechnicalError from './news-technical-error/news-technical-error.vue';
import NoResult from './news-no-result/news-no-result.vue';
import { defineComponent } from '@vue/composition-api';
import { useNewsStore } from './composables/news-composable';
import { FORM_STATES } from './constants/constants';
export default defineComponent({
	name: 'News',
	components: {
		NewsList,
		NewsTags,
		VuePagination,
		VueSpinner,
		TechnicalError,
		NoResult
	},
	props: {
		pageSize: {
			type: Number,
			default: 10
		}
	},
	setup(props) {
		const { currentPage, totalRows, header, formState, setPageSize } = useNewsStore();
		setPageSize(props.pageSize);
		return {
			currentPage,
			totalRows,
			header,
			formState,
			FORM_STATES
		};
	}
});
</script>
<style lang="scss" scoped>
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.news-container {
	@include media('>=tablet') {
		display: flex;
	}
}

.news-col {
	flex-grow: 1;
	order: 1;
}

.news-col--small {
	@include media('>=tablet') {
		margin-left: 16px;
		max-width: 32%;
		min-width: 32%;
		order: 2;
	}

	@include media('>=tablet') {
		margin-left: 32px;
	}
}

.news-spinner {
	align-items: center;
	display: flex;
	min-height: 600px;
	position: relative;
}
</style>
